import { Link } from "react-router-dom";
import React, { useState, memo } from "react";
import { forwardRef } from 'react';
import { Form, InputGroup } from "react-bootstrap";
import { Field } from "react-final-form";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'


export default function UiMobileInput(props) {
    

    return (
        <>
        <Field
            name={props.name}
            render={({ input, meta }) => {
                return (
                    <>
                        <div className="sb-input-wrapper sb-mobile-input-wr-comp">
                            <Form.Group controlId={props.id}>
                                {props.label && (
                                    <Form.Label>{props.label}</Form.Label>
                                )}

                                <PhoneInput  
                                    placeholder={props.placeholder}
                                    international
                                    countryCallingCodeEditable={false}
                                    {...input} 
                                    defaultCountry="GB" 
                                    className={meta.error && meta.touched ? 'sb-mobile-is-invalid':''}/>

                                <div className="sb-mobile-is-invalid-text">
                                    {meta.error && meta.touched && <span>{meta.error}</span>}
                                </div>                                                
                            </Form.Group>
                        </div>
                    </>
                );
            }}
        />
            
        </>
    )
}





